<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-04 10:53:55
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-11 13:33:22
-->
<template>
  <div class="Cashier">
    <div class="changeinto">
      {{ isJustText }}
    </div>
    <div class="changeto_header">
      <div class="changeto_header_money_box">
        <div :class="isClass">
          <span>{{ isPlusSign }}</span
          >{{ milliFormat(money) }}元
        </div>
        <div class="changeto_header_money_tip">交易成功</div>
      </div>
    </div>
    <List left="交易时间" :right="timer" />
    <List left="||类账户余额" :right="`¥${balance}`" />
    <List :left="this.isJust ? '付款账户名' : '收款账户名'" :right="accountName" />
    <List :left="this.isJust ? '付款银行' : '收款银行'" :right="bank" />
    <List left="银行行号" :right="account" />
    <Button text="返回" class="nextStep" :click="goToNextPage" />
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import List from '@/components/List.vue';
import { milliFormat } from '@/utils';

export default {
  name: 'Cashier',
  data() {
    return {
      timer: '',
      balance: '',
      accountName: '',
      bank: '',
      account: '',
      money: '',
    };
  },
  components: {
    List,
    Button,
  },
  props: ['isJust'],
  mounted() {
    window.document.title = this.isJust ? '转入明细' : '转出明细';
    const {
      // eslint-disable-next-line camelcase
      tran_time,
      // eslint-disable-next-line camelcase
      trans_amt,
      // eslint-disable-next-line camelcase
      acct_bal,
      // eslint-disable-next-line camelcase
      cnter_bank_no,
      // eslint-disable-next-line camelcase
      cnter_bank_name,
      // eslint-disable-next-line camelcase
      tran_cnter_name,
    } = this.$router.currentRoute.query;
    console.log(this.$router.currentRoute.query);
    // eslint-disable-next-line camelcase
    this.bank = cnter_bank_name;
    // eslint-disable-next-line camelcase
    this.account = cnter_bank_no;
    // eslint-disable-next-line camelcase
    this.accountName = tran_cnter_name ? `*${tran_cnter_name.slice(1)}` : '';
    // eslint-disable-next-line camelcase
    this.timer = `${tran_time}`;
    this.balance = milliFormat(acct_bal);
    // eslint-disable-next-line camelcase
    this.money = trans_amt;
  },
  computed: {
    isJustText() {
      return this.isJust ? '转入' : '转出';
    },
    isPlusSign() {
      return this.isJust ? '+' : '-';
    },
    isClass() {
      return this.isJust
        ? 'changeto_header_money_red'
        : 'changeto_header_money_green';
    },
  },

  methods: {
    milliFormat(val) {
      return milliFormat(val);
    },
    goToNextPage() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 27px;
}
.Cashier >>> .van-button--default {
  background-image: linear-gradient(180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 8px;
  border-radius: 8px;
  font-size: 17px;
  color: #fff;
}
.changeinto {
  text-align: left;
  padding: 30px 0 0 24px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #505659;
}
.changeto_header_money_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.changeto_header {
  height: 180px;
}
.changeto_header_money_red {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #ff6538;
}
.changeto_header_money_green {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #40d970;
}
.changeto_header_money_tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
  padding-top: 12px;
}
</style>
